/* ============================================================
 * <lion-hotspot> — lookbook product tag.
 * Click/tap toggles a product mini-card. Closes on outside
 * click or Escape. Multiple hotspots coordinate via a shared
 * document-level listener so only one stays open at a time.
 * ============================================================ */

if (!customElements.get('lion-hotspot')) {
  class LionHotspot extends HTMLElement {
    constructor() {
      super();
      this.btn = this.querySelector('.lookbook__hotspot-btn');
      this.card = this.querySelector('.lookbook__hotspot-card');
    }

    connectedCallback() {
      if (!this.btn || !this.card) return;
      this.btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggle();
      });
      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseenter', () => this.open());
        this.addEventListener('mouseleave', () => this.close());
      }
    }

    toggle() {
      if (this.card.hasAttribute('hidden')) this.open();
      else this.close();
    }

    open() {
      document.querySelectorAll('lion-hotspot').forEach((el) => {
        if (el !== this) el.close();
      });
      this.card.removeAttribute('hidden');
      this.btn.setAttribute('aria-expanded', 'true');
      this.rientraNelloSchermo();
      this._onOutside = (e) => { if (!this.contains(e.target)) this.close(); };
      this._onEsc = (e) => { if (e.key === 'Escape') this.close(); };
      setTimeout(() => {
        document.addEventListener('click', this._onOutside);
        document.addEventListener('keydown', this._onEsc);
      }, 0);
    }

    /**
     * La scheda e' centrata sul pallino, quindi su un pallino vicino al bordo
     * meta' scheda finisce fuori dallo schermo e il prezzo non si legge. Il
     * CSS da solo non basta: la posizione del pallino e' una percentuale della
     * foto, non ricavabile dentro la scheda. Qui si misura e si sposta di
     * quanto serve, mai piu' del necessario, cosi' al centro resta centrata.
     */
    rientraNelloSchermo() {
      this.card.style.setProperty('--scarto', '0px');
      const margine = 12;
      const zona = this.card.getBoundingClientRect();
      const larghezza = document.documentElement.clientWidth;
      let scarto = 0;
      if (zona.left < margine) {
        scarto = margine - zona.left;
      } else if (zona.right > larghezza - margine) {
        scarto = larghezza - margine - zona.right;
      }
      this.card.style.setProperty('--scarto', `${Math.round(scarto)}px`);
    }

    close() {
      this.card.setAttribute('hidden', '');
      this.btn.setAttribute('aria-expanded', 'false');
      if (this._onOutside) document.removeEventListener('click', this._onOutside);
      if (this._onEsc) document.removeEventListener('keydown', this._onEsc);
    }
  }

  customElements.define('lion-hotspot', LionHotspot);
}
